export const orgStructure = {
  sectionTitle: '组织架构',
  sectionSubtitle: 'ORGANIZATION STRUCTURE',
  sectionDesc: '科学完善的企业组织架构，是品牌稳健运营与持续发展的根本保障。',
  levels: [
    { id: 'board-chairman', title: '董事会主席', icon: 'ri-building-line', level: 0 },
    { id: 'chairman', title: '董事长', icon: 'ri-vip-crown-line', level: 1 },
    { id: 'ceo', title: '总经理', icon: 'ri-user-star-line', level: 2 },
  ],
  departments: [
    { id: 'ops', title: 'AI研发', icon: 'ri-store-2-line', desc: '持续探索AI应用\n提升系统效率与智能化', color: 'accent' },
    { id: 'franchise', title: '线上营销', icon: 'ri-group-line', desc: '强化线上获客能力\n扩大流量入口', color: 'primary' },
    { id: 'brand', title: '运营', icon: 'ri-megaphone-line', desc: '沉淀运营和文化赋能\n打造可复制的能力', color: 'secondary' },
    { id: 'rd', title: '门店', icon: 'ri-flask-line', desc: '统管门店运营和服务\n促进转化与增长', color: 'accent' },
    { id: 'finance', title: '财务', icon: 'ri-funds-line', desc: '统一资金核算\n打造合规资本底座', color: 'secondary' },
    { id: 'hr', title: '招商加盟', icon: 'ri-team-line', desc: '推进加盟体系\n结合资本加速扩张', color: 'primary' },
  ],
};

export const executiveTeam = [
  {
    name: '陈志远',
    title: '董事长 / 创始人',
    specialty: '品牌战略规划',
    bio: '深耕健康管理行业二十余年，先后创立多个知名连锁品牌，累计管理门店超过300家。2018年创立颜轻至品牌，以"让中医养生回归日常"为使命，主导品牌从0到1的战略布局，完成从西北区域试点到全国17城连锁扩张的全过程。拥有北京大学EMBA学位，中国连锁经营协会常务理事。',
    tags: ['品牌战略', '连锁经营', '产业投资'],
    imagePrompt: 'Senior Chinese business executive in elegant dark suit with subtle pinstripe, confident authoritative yet warm expression, sitting in luxurious modern boardroom with floor-to-ceiling windows overlooking city skyline, soft natural light, East Asian male around 55, high-end executive portrait photography, sophisticated premium atmosphere, cream and beige color tones',
    imageUrl: '',
  },
  {
    name: '林雅雯',
    title: 'CEO / 联合创始人',
    specialty: '企业经营管理',
    bio: '十六年大健康行业从业经验，曾任跨国健康管理集团亚太区运营副总裁，管理跨区域团队超500人。2020年加入颜轻至担任CEO，全面负责公司日常运营、组织体系搭建与人才梯队建设，推动企业从初创期稳步迈入规模化发展阶段。持有复旦大学MBA学位及国际注册健康管理师认证，擅长精细化运营与组织效能提升。',
    tags: ['运营管理', '组织建设', '人才发展'],
    imagePrompt: 'Professional female CEO in elegant cream white business suit, confident warm smile with sharp intelligent eyes, standing in bright modern minimalist office with warm natural lighting, East Asian woman around 42, premium executive portrait photography, sophisticated corporate atmosphere, soft beige cream color palette',
    imageUrl: '',
  },
  {
    name: '王启明',
    title: '运营副总裁',
    specialty: '精细化运营管理',
    bio: '十五年连锁服务业运营管理经验，曾在国际五星级酒店集团担任区域运营总监七年。2021年加入颜轻至，主导搭建了覆盖全国17城的标准化运营体系，推动门店人效提升35%，客户满意度连续三年保持95%以上。擅长数据驱动的精细化运营，将传统养生服务与现代管理工具深度融合。',
    tags: ['精细化运营', '标准化体系', '数据驱动'],
    imagePrompt: 'Middle-aged Chinese male executive in tailored navy business suit, analytical and focused expression, standing in front of large digital screens showing operational data dashboards, modern corporate operations center, East Asian male around 48, professional executive portrait, warm ambient lighting, cream and beige corporate tones',
    imageUrl: '',
  },
  {
    name: '陈思涵',
    title: '财务副总裁',
    specialty: '财务战略与资本运作',
    bio: '拥有中国注册会计师（CPA）及特许金融分析师（CFA）双证，曾在四大会计师事务所担任审计高级经理八年，后转入连锁消费领域担任集团财务总监。2020年加入颜轻至，全面负责财务战略规划、融资管理和内部控制体系搭建，主导完成B轮融资，为企业规模化扩张提供坚实的财务保障。',
    tags: ['财务战略', '资本运作', '风控管理'],
    imagePrompt: 'Professional Chinese female finance executive in elegant light gray suit, composed and trustworthy expression, standing in bright modern office with glass walls and warm natural lighting, East Asian woman around 44, premium corporate portrait, sophisticated atmosphere, cream and soft gray color palette',
    imageUrl: '',
  },
  {
    name: '赵立诚',
    title: '人力资源副总裁',
    specialty: '组织发展与人才战略',
    bio: '二十年人力资源管理经验，曾服务于世界500强制药企业及国内头部连锁零售集团，深度参与过三次企业上市前组织变革。2022年加入颜轻至，主导搭建了基于胜任力模型的人才选拔与培养体系，推动企业文化建设与员工敬业度提升项目。持有北京大学心理学硕士及国际行动学习协会认证催化师资格。',
    tags: ['组织发展', '人才战略', '企业文化'],
    imagePrompt: 'Senior Chinese male HR executive in warm-toned smart casual blazer, approachable yet professional expression, sitting in a bright modern office lounge area with plants and warm sunlight, East Asian male around 52, professional lifestyle portrait, warm cream and natural green tones',
    imageUrl: '',
  },
];

export const managementTeam = [
  {
    name: '赵明辉',
    title: '运营总监',
    specialty: '门店运营与区域管理',
    years: '12年',
    message: '用标准化的服务流程与人性化的管理理念，让每一家门店都成为顾客信赖的健康驿站。',
    bio: '十年连锁门店运营管理经验，负责全国门店运营标准制定、区域督导体系搭建及门店服务水平持续提升，确保各区域门店服务品质一致。',
    tags: ['门店运营', '区域管理', '服务标准'],
    imagePrompt: 'Professional operations director in smart business casual attire, confident and practical demeanor, standing in a clean modern wellness store environment, East Asian male around 40, professional portrait, warm lighting',
    imageUrl: '',
  },
  {
    name: '刘思远',
    title: '招商总监',
    specialty: '渠道拓展与加盟管理',
    years: '15年',
    message: '以诚相待每一位合作伙伴，用专业的加盟服务体系助力更多人实现创业梦想。',
    bio: '十二年招商加盟领域从业经验，精通加盟政策设计、渠道布局与加盟商服务体系搭建。主导品牌全国加盟网络拓展与加盟商关系维护。',
    tags: ['渠道拓展', '加盟管理', '商务谈判'],
    imagePrompt: 'Professional business development director in modern suit, outgoing and trustworthy smile, in a contemporary corporate office with warm beige tones, East Asian male around 42, confident executive portrait',
    imageUrl: '',
  },
  {
    name: '张雅琳',
    title: '品牌总监',
    specialty: '品牌建设与传播',
    years: '9年',
    message: '让品牌有温度、有态度，用内容连接用户心智，让颜轻至成为健康生活方式的代名词。',
    bio: '八年品牌管理工作经验，擅长品牌定位、内容策略与整合营销传播。负责品牌形象塑造、新媒体矩阵运营及线下品牌活动策划执行。',
    tags: ['品牌策略', '内容营销', '活动策划'],
    imagePrompt: 'Creative female brand director in elegant professional attire, warm and stylish, in a modern creative workspace with natural light, East Asian woman around 35, professional lifestyle portrait',
    imageUrl: '',
  },
  {
    name: '杨国栋',
    title: '产品研发总监',
    specialty: '产品研发与品质管理',
    years: '18年',
    message: '坚持天然草本与现代科技深度融合的研发理念，每一款产品都经得起时间与效果的检验。',
    bio: '十余年健康产品研发经验，主导多款核心护理产品的配方研发与品质标准制定。坚持天然草本与现代科技结合的研发理念，确保产品安全有效。',
    tags: ['产品研发', '配方工艺', '品质管控'],
    imagePrompt: 'Senior male R&D director in professional lab attire, focused and knowledgeable expression, in a modern laboratory setting with natural herbal ingredients, East Asian male around 48, professional portrait, scientific atmosphere',
    imageUrl: '',
  },
  {
    name: '周晓琳',
    title: '培训总监',
    specialty: '人才培训与技能提升',
    years: '10年',
    message: '以体系化的培训赋能每一位员工，让专业服务能力成为品牌最坚实的护城河。',
    bio: '十年企业培训管理经验，主导搭建品牌内部培训学院，涵盖技术培训、服务标准化培训及管理力培训三大体系，年培训人次超2000。',
    tags: ['培训体系', '技能提升', '人才赋能'],
    imagePrompt: 'Professional female training director in elegant light-colored outfit, warm and encouraging expression, in a modern training classroom with natural light, East Asian woman around 38, professional portrait, warm cream tones',
    imageUrl: '',
  },
  {
    name: '马骏飞',
    title: '供应链总监',
    specialty: '供应链管理与品控',
    years: '14年',
    message: '从源头到终端，每一个环节的可控，才是对品质最好的承诺。',
    bio: '十四年供应链管理经验，主导搭建品牌全国供应链体系，建立严格的供应商评估与原料溯源机制，确保核心原料品质稳定、供应安全。',
    tags: ['供应链', '品质管控', '原料溯源'],
    imagePrompt: 'Chinese male supply chain director in professional smart casual attire, reliable and meticulous expression, in a modern warehouse logistics center with organized inventory, East Asian male around 43, professional portrait, warm industrial lighting',
    imageUrl: '',
  },
  {
    name: '林志峰',
    title: '信息技术总监',
    specialty: '数字化建设与技术架构',
    years: '11年',
    message: '以技术驱动效率革新，用数字化的力量让传统养生行业焕发全新活力。',
    bio: '十一年互联网技术管理经验，主导品牌数字化系统建设，包括智慧门店管理系统、会员数据中台及加盟商协同平台，推动企业全链路数字化升级。',
    tags: ['数字化', '系统架构', '数据中台'],
    imagePrompt: 'Chinese male IT director in modern casual blazer, innovative and focused expression, in a contemporary tech-enabled workspace with warm ambient lighting, East Asian male around 39, professional portrait, cream and soft gray tones',
    imageUrl: '',
  },
  {
    name: '苏婉清',
    title: '客户体验总监',
    specialty: '客户体验与服务设计',
    years: '8年',
    message: '倾听每一位顾客的声音，让每一次服务都成为超越期待的温暖体验。',
    bio: '八年客户体验管理经验，主导品牌服务旅程设计、客户满意度监测体系搭建及服务标准迭代，推动NPS净推荐值连续两年提升超20%。',
    tags: ['客户体验', '服务设计', '满意度管理'],
    imagePrompt: 'Chinese female customer experience director in warm-toned elegant attire, empathetic and attentive expression, in a beautiful modern wellness spa reception area with soft lighting, East Asian woman around 34, professional lifestyle portrait, cream and warm blush tones',
    imageUrl: '',
  },
];

export const managementHero = {
  title: '专业的管理团队，引领品牌稳健发展',
  subtitle: 'MANAGEMENT TEAM',
  description: '麦杰集团拥有一支经验丰富、专业过硬的管理团队，涵盖运营、招商、品牌、研发、财务等核心职能，为颜轻至品牌持续健康发展和全国市场拓展提供强有力的组织保障。',
};

export const managementStats = [
  { value: '20年+', label: '平均行业经验' },
  { value: '5大', label: '核心管理中心' },
  { value: '200+', label: '团队协作覆盖' },
  { value: '17+', label: '城市市场布局' },
];

// 兼容性导出（用于旧组件）
export const experts = managementTeam;
export const expertsHero = managementHero;
export const stats = managementStats;
export const supportModules = [
  {
    id: 'product-rd',
    icon: 'ri-flask-line',
    title: '产品研发支持',
    subtitle: '研发实力',
    desc: '持续投入产品研发，结合现代科技与传统中医，为加盟商提供安全有效的核心产品支撑。',
    description: '持续投入产品研发，结合现代科技与传统中医，为加盟商提供安全有效的核心产品支撑。',
    items: ['配方研发', '品质管控', '产品迭代'],
  },
  {
    id: 'training',
    icon: 'ri-team-line',
    title: '培训赋能支持',
    subtitle: '培训体系',
    desc: '提供系统化的技术培训与运营培训，帮助加盟商团队快速掌握专业服务技能。',
    description: '提供系统化的技术培训与运营培训，帮助加盟商团队快速掌握专业服务技能。',
    items: ['技术培训', '服务标准', '管理培训'],
  },
  {
    id: 'digital-ops',
    icon: 'ri-line-chart-line',
    title: '数字化运营支持',
    subtitle: '数字化',
    desc: '提供智慧门店管理系统与数据分析工具，助力加盟商实现精细化、数字化运营管理。',
    description: '提供智慧门店管理系统与数据分析工具，助力加盟商实现精细化、数字化运营管理。',
    items: ['门店系统', '数据分析', '会员管理'],
  },
];